import { ApiService } from "src/network/apiService";
import { IApiResponse } from "src/network/models/ApiResponse";
import { IContactModel, IUserScope } from "src/types/models/apiModels";
import { TUserScope } from "../invite-user/invite-user.view-model";
import { TProductPlan } from "src/components/molecules/product-plan-marker/product-plan-marker";
import { root } from "postcss";

export interface IInviteUserRequest {
    emailId: string;
    roleId: string;
}

export interface IInviteUserResponse {
    emailId: string;
    success: boolean;
    message: string;
}

export interface ICreateAccountRequestModel {
    name: string;
    rootEmailId: string;
    isMultiBusiness: boolean;
    productPlan: TProductPlan
}

export interface IAccountModel {
    accountId: string;
    name: string;
    rootUser: IContactModel
    productPlan: TProductPlan
}

export class AccountManagementViewModel {
    private apiService: ApiService;

    constructor(accessToken: string) {
        this.apiService = new ApiService({ accessToken: accessToken });
    }

    async getAccountContactsAsync(): Promise<IContactModel[]> {
        const URL = `/onboard/contacts`
        const response = await this.apiService.getAsync<IApiResponse<IContactModel[]>>(URL);
        return response.scResponse.data;
    }

    async getAccountAsync(): Promise<IAccountModel> {
        const URL = `/onboard/account`
        const response = await this.apiService.getAsync<IApiResponse<IAccountModel>>(URL);
        return response.scResponse.data;
    }

    async fetchUserScopesAsync(level: TUserScope): Promise<IUserScope[] | null> {
        const URL = `/onboard/roles?scope=${level}`
        const response = await this.apiService.getAsync<IApiResponse<IUserScope[]>>(URL);

        if (response.scResponse.code === 2000) {
            return response.scResponse.data;
        }

        return null;
    }

    async inviteUserAsync(emailId: string, roleId: string): Promise<IInviteUserResponse> {
        const URL = `/onboard/contact`

        const body: IInviteUserRequest = {
            emailId: emailId,
            roleId: roleId
        }

        const response = await this.apiService.postAsync<IApiResponse<string>, IInviteUserRequest>(URL, body)

        console.log(response);

        if (response && response.scResponse.code === 2000) {
            return {
                emailId: emailId,
                success: true,
                message: response.scResponse.data
            }
        } else {
            return {
                emailId: emailId,
                success: false,
                message: response.scResponse.message
            }
        }
    }

    async submitAccountUpdateAsync(accountName: string, rootEmailId: string): Promise<boolean> {
        const URL = `/onboard/account`

        const body = {
            name: accountName,
            rootEmailId: rootEmailId
        }

        try {
            const response = await this.apiService.putAsync<IApiResponse<any>, any>(URL, body);

            if (response && response.scResponse.code === 2000) {
                return true;
            }
        } catch (error) {
            return false
        }

        return false;
    }

    async createAccountAsync(resellerId: string, account: ICreateAccountRequestModel): Promise<boolean> {
        const URL = `/onboard/${resellerId}/account`;

        try {

            const response = await this.apiService.postAsync<IApiResponse<any>, ICreateAccountRequestModel>(URL, account);

            console.log(`create account response`, response);
            if (response.scResponse.code === 2000) {
                return true;
            }
        } catch (error) {
            return false
        }
        return false
    }
}